import React from 'react';

interface MetricCellHeader {
  type: 'value' | 'tier' | 'on?';
}

export const MetricCellHeader: React.FC<MetricCellHeader> = ({ type }) => {
  return <div style={{ textTransform: 'capitalize' }}>{type}</div>;
};
